<template lang="pug">
    iframe(width='100%' height='500' :src="urlArcgis" v-if="UTILIZA_ARCGIS")
    #base.round(:style="{ height: height }" v-else)
      #loader(
        v-if="isLoading"
        v-loading="isLoading"
        element-loading-text="Carregando camadas..."
      )
      #mapa.round
      transition(name="slide")
        #camadas(v-if="isCamadasOpen")
          #content
            #header
              span#title Camadas
            #body
              .item(v-for="item in camadas")
                el-collapse(v-if="item.subcamadas" v-model="item.activeDropdown")
                  el-collapse-item(name="1" :title="item.layerName")
                    template(slot="title")
                      .check
                        img.legend(:src="`${urlProcessos}/2/images/${item.legend[0].url}`")
                      .checkbox
                        span {{ item.layerName }}
                    .check.subcamada(v-for="tipo in filtros.tipo")
                      .check
                        el-checkbox(:disabled="isLoading" v-model="tipo.ativo")
                      .checkbox
                        span {{ tipo.nome }}
                .check(v-else)
                  .check
                    el-checkbox(v-model="item.checked", @change="changeCheckboxCamadas", :disabled="isLoading")
                    img.legend(:src="`${urlCamadas}/${item.layerId}/images/${item.legend[0].url}`" v-bind:class="{ border: item.layerId === 3 }")
                  .checkbox
                    span {{ item.layerName }}

</template>

<script>
import L from 'leaflet'
import * as esri from 'esri-leaflet'
import 'leaflet-easybutton'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
import { mapActions, mapState } from 'vuex'
import enumFormatter from '@/utils/EnumFormatter'
import _ from 'lodash'

// BUG https://github.com/Leaflet/Leaflet/issues/4968
L.Marker.prototype.options.icon = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
})

const TILE_LAYER_CONFIG = {
  url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
  attribution: 'Tiles © <a href="http://www.esri.com/" target="_blank">Esri</a>'
}

const DEFAULT_CONFIG = {
  center: [-4.446367, -52.448730],
  topLeft: [2.591027, -58.898328],
  bottomRight: [-9.841153, -46.061425],
  zoom: 6,
  minZoom: 6,
  maxZoom: 16,
  attributionControl: true,
  maxBoundsViscosity: 1,
  maxBounds: [[-90, -180], [90, 180]]
}

export default {

  name: 'Mapa',

  mixins: [
    AppNotificacao
  ],

  props: {
    buttons: {
      required: false,
      type: Array,
      default: () => []
    },
    height: {
      required: false,
      type: String,
      default: '100%'
    },
    mapConfig: {
      required: false,
      type: Object
    },
    locked: {
      required: false,
      type: Boolean,
      default: false
    },
    processos: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      mapa: null,
      config: {},
      featureGroup: null,
      buttonsArray: [],
      isLoading: false,
      mapServer: {},
      mapProcess: {},
      urlCamadas: null,
      urlProcessos: null,
      urlMunicipios: null,
      isCamadasOpen: false,
      camadas: [],
      localLayer: null,
      tiposProcessos: [],
      statusProcessos: [],
      selectedTiposProcessos: [],
      filtros: {},
      urlArcgis: 'https://arcgisportal.iterpa.pa.gov.br/portal/apps/webappviewer/index.html?id=e4d9d813568c49b9b75c250b38af9462'
    }
  },

  computed: {
    ...mapState({
      UTILIZA_ARCGIS: state => state.userInterface.dadosEstado.UTILIZA_ARCGIS
    }),

    query: function () {
      const codigoTiposFiltrados = this.filtros.tipo.filter(item => item.ativo === false).map(item => `${item.id}`)

      const queryTipos = codigoTiposFiltrados.length > 0 ? `id_tipo_cadastro NOT IN (${codigoTiposFiltrados.join(',')})` : ''
      const queryProcessos = this.processos.length > 0 ? `numero_processo IN (${this.processos.map(item => `'${item}'`).join(',')})` : ''

      const resultado = [queryTipos, queryProcessos].filter(item => item !== '').join(' AND ')

      return resultado
    }
  },

  methods: {
    ...mapActions({
      getTiposProcessos: 'processos/getTiposProcessosPromise',
      getStatusProcessos: 'processos/getStatusPromise'
    }),
    changeCheckboxCamadas () {
      const camadasChecked = this.camadas.filter(item => item.checked).map(item => item.layerId)
      this.mapServer.setLayers(camadasChecked)
    },
    changeCheckboxTipoProcesso (tipo) {
      this.filtros.tipo.push(tipo)
    },
    openCamadas (button) {
      button.state('camadas-active')
      this.isCamadasOpen = true
    },
    closeCamadas (button) {
      button.state('camadas-inactive')
      this.isCamadasOpen = false
    },
    mapServerOnLoading () {
      this.isLoading = true
    },
    mapServerOnLoad () {
      this.isLoading = false
    },
    configureLayers () {
      this.mapServer = esri.dynamicMapLayer({
        f: 'image',
        url: this.urlCamadas,
        useCors: false,
        transparent: true,
        maxZoom: DEFAULT_CONFIG.maxZoom,
        minZoom: DEFAULT_CONFIG.minZoom,
        format: 'png32',
        layers: []
      })

      this.mapServer.on('load', this.mapServerOnLoad)
      this.mapServer.on('loading', this.mapServerOnLoading)

      esri.request(`${this.urlCamadas}/legend`, {}, async (_, response) => {
        this.camadas = response.layers.map(item => { return { ...item, checked: false, isLoading: false, isLoaded: false } })

        esri.request(`${this.urlProcessos}/legend`, {}, async (_, response) => {
          const index = this.getIndexCamadaByLayerId(this.camadas, 5)
          const camada = { ...this.camadas[index], legend: response.layers[2].legend }
          const subcamadas = this.tiposProcessos.map(item => { return { tipo: item, checked: false, isLoading: false, isLoaded: false } })
          this.camadas.splice(index, 1)
          this.camadas.push({ ...camada, subcamadas })
        })
      })

      this.mapServer.addTo(this.mapa)
    },

    getIndexCamadaByLayerId (camadas, id) {
      return _.findIndex(camadas, item => item.layerId === id)
    },

    configureButtons (receivedButtons) {
      this.buttonsArray.forEach(button => button.remove())

      this.buttonsArray = receivedButtons.map(element => {
        let item = L.easyButton({
          id: element.id,
          position: 'topleft',
          type: 'replace',
          leafletClasses: true,
          states: [{
            stateName: element.id + '-active',
            title: element.tooltip,
            icon: element.icon,
            onClick: element.onClick
          }]
        })
        item.addTo(this.mapa)
        return item
      })

      const buttonCamadas = L.easyButton({
        id: 'button-camadas',
        position: 'topleft',
        type: 'replace',
        leafletClasses: true,
        states: [{
          stateName: 'camadas-inactive',
          title: 'Camadas',
          icon: '<i class="material-icons layer-icon">layers</i>',
          onClick: (button) => this.openCamadas(button)
        },
        {
          stateName: 'camadas-active',
          title: 'Camadas',
          icon: '<i class="material-icons layer-icon">layers</i>',
          onClick: (button) => this.closeCamadas(button)
        }]
      })

      if (this.isCamadasOpen) {
        buttonCamadas.state('camadas-active')
      }
      this.buttonsArray = [...this.buttonsArray, buttonCamadas]

      if (this.UTILIZA_ARCGIS) {
        buttonCamadas.addTo(this.mapa)
      }
    },

    createMap () {
      // Criando mapa
      this.mapa = L.map('mapa', this.config)

      L.tileLayer(TILE_LAYER_CONFIG.url, {
        noWrap: true,
        attribution: TILE_LAYER_CONFIG.attribution
      }).addTo(this.mapa)

      this.refreshMap()

      this.lockMap(this.locked)
    },

    recenterView () {
      if (this.UTILIZA_ARCGIS) {
        this.mapa.fitBounds([DEFAULT_CONFIG.topLeft, DEFAULT_CONFIG.bottomRight])
      } else {
        this.mapa.fitBounds(this.localLayer.getBounds())
      }
    },

    configureMap () {
      for (let propertyName in DEFAULT_CONFIG) {
        this.config[propertyName] = this.mapConfig && this.mapConfig[propertyName]
          ? this.mapConfig[propertyName] : DEFAULT_CONFIG[propertyName]
      }
    },

    refreshMap () {
      if (this.featureGroup && this.featureGroup.getBounds()) {
        if (Object.keys(this.featureGroup.getBounds()).length > 0) {
          this.mapa.invalidateSize()
          this.mapa.fitBounds(this.featureGroup.getBounds())
        }
      }
    },

    lockMap (mapLock) {
      let lockFunc = 'enable'
      if (mapLock === true) {
        lockFunc = 'disable'
      }

      this.mapa.dragging[lockFunc]()
      this.mapa.touchZoom[lockFunc]()
      this.mapa.doubleClickZoom[lockFunc]()
      this.mapa.scrollWheelZoom[lockFunc]()
      this.mapa.boxZoom[lockFunc]()
      this.mapa.keyboard[lockFunc]()

      if (this.mapa.tap) this.mapa.tap[lockFunc]()
    },

    montarPopup (error, featureCollection, response) {
      if (error) {
        return `Erro ao obter dados: ${error}`
      }
      if (response.results.length) {
        const data = response.results.map(item => item.attributes)
        const groupped = this.groupBy(data, 'numero_processo')
        const keys = Object.keys(groupped)
        const attributes = keys.map(key => {
          const item = groupped[key][0]
          const values = `
            <div class='break'>
              <div class='break'><b>Número do processo:</b> ${item['numero_processo'] || ' - '}</div>
              <div class='break'><b>Tipo:</b> ${this.getTipo(item['id_tipo_cadastro'])}</div>
              <div class='break'><b>Status:</b> ${this.getStatus(item['status'])}</div>
              <div class='break'><b>Nome/razão social:</b> ${item['interessado_nome_razao_social'] || ' - '}</div>
            </div>
          `
          return values
        }).join('</br>')
        return `<div class='popup'>${attributes}</div>`
      }
    },

    getTipo (id) {
      if (id) {
        const idTipoCadastro = parseInt(id, 10)
        return this.tiposProcessos.filter(element => element.id === idTipoCadastro)[0].nome
      } else {
        return ' - '
      }
    },

    getStatus (codigo) {
      return enumFormatter.getStatusFormatado(codigo)
    },

    groupBy (objectArray, property) {
      return objectArray.reduce((accumulator, object) => {
        const key = object[property]
        if (!accumulator[key]) {
          accumulator[key] = []
        }
        accumulator[key].push(object)
        return accumulator
      }, {})
    }

  },

  created () {
    this.urlProcessos = process.env.URL_MAPSERVER_PROCESSOS
    this.urlMunicipios = process.env.URL_MAPSERVER_MUNICIPIOS
    this.urlCamadas = process.env.URL_MAPSERVER_CAMADAS
    this.bancoSicarf = process.env.BANCO_SICARF
  },

  async mounted () {
    this.tiposProcessos = await this.getTiposProcessos()
    const statusProcessos = await this.getStatusProcessos()
    this.statusProcessos = statusProcessos.map(item => { return { nome: enumFormatter.getStatusFormatado(item), codigo: item } })

    const filtroTiposProcessos = ['GENERICO', 'INFORMACOES', 'PEAS_FILHO']
    const tiposProcessosFiltrados = this.tiposProcessos.filter(item => filtroTiposProcessos.indexOf(item.codigo) < 0)
    const tiposProcessosFiltro = tiposProcessosFiltrados.map(item => { return { ...item, ativo: true } })
    this.filtros = { ...this.filtros, tipo: tiposProcessosFiltro }

    this.configureMap()

    if (!this.mapa) {
      this.createMap()
    }

    this.mapserverMunicipios = esri.dynamicMapLayer({
      url: this.urlMunicipios,
      useCors: false,
      format: 'png32',
      layers: [0],
      maxZoom: DEFAULT_CONFIG.maxZoom,
      minZoom: DEFAULT_CONFIG.minZoom
    })

    this.mapserverProcessos = esri.dynamicMapLayer({
      url: this.urlProcessos,
      useCors: false,
      layers: [0, 1, 2],
      transparent: true,
      maxZoom: DEFAULT_CONFIG.maxZoom,
      minZoom: DEFAULT_CONFIG.minZoom,
      format: 'png32'
    })

    this.mapserverProcessos.bindPopup(this.montarPopup)

    this.mapserverProcessos.on('load', this.mapServerOnLoad)
    this.mapserverProcessos.on('loading', this.mapServerOnLoading)

    this.mapserverMunicipios.addTo(this.mapa)
    this.mapserverProcessos.addTo(this.mapa)

    this.configureButtons(this.buttons)

    this.configureLayers()
  },

  watch: {
    buttons: {
      handler (val) {
        this.configureButtons(val)
      },
      deep: true
    },
    filtros: {
      deep: true,
      handler () {
        if (this.mapserverProcessos) {
          this.mapServerOnLoading = true
          this.mapserverProcessos.setLayerDefs({ 0: this.query, 1: this.query, 2: this.query })
        }
      }
    },
    processos: {
      deep: true,
      handler () {
        if (this.mapserverProcessos) {
          this.mapServerOnLoading = true
          this.mapserverProcessos.setLayerDefs({ 0: this.query, 1: this.query, 2: this.query })
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.round {
  border-radius: 10px;
}

#base {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

#loader {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 1000;
}

#mapa {
  height: 100%;
  width: 100%;
}

#camadas {
  z-index: 1000;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  left: 54px;
  top: 10px;

  #content {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: flex-start;
    min-width: 15rem;
    max-width: 17rem;
    border-radius: 4px;
    background-color: $white;
    cursor: default;

    #header {
      width: 100%;
      height: 36px;
      background-color: $color-primary;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      #title {
        color: $white;
        font-size: 1rem;
        font-weight: bold;
        margin-left: 0.75rem;
      }
    }
    #body {
      width: 100%;
      padding: 0.75rem;
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      align-items: flex-start;

      .item {
        padding-top: 0.15rem;
        padding-bottom: 0.15rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        .check {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-right: 0.5rem;

          .legend {
            margin-left: 0.5rem;
            height: 14px;
            width: 14px;
          }
        }

        .checkbox {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          flex: 1;
        }
      }
    }
  }
}

.border {
  border: 1px $font-dark-color solid;
}

.slide-enter-active {
  transition: all 0.5s;
}
.slide-leave-active {
  transition: all 0.5s;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-58px);
  opacity: 0;
}

.el-collapse {
  width: 100%;
  border: none
}
.el-collapse-item {
  padding-left: 14px;
}

.subcamada {
  padding-top: 1px;
  padding-left: 18px;

  span {
    color: $font-color;
  }
}

>>> .el-collapse-item__header {
  color: #909399;
  font-size: 16px;
  border-bottom: none;
  height: 20px;
}
>>> .el-collapse-item__content {
  line-height: 1.5;
  overflow-y: auto;
  max-height: 150px;
}

>>> .el-collapse-item__wrap {
  border: none;
}
</style>

<style lang="scss">
@import '@/assets/styles/_variables.scss';

.state-camadas-active {
  color: $color-primary;
}

.easy-button-button {
  border: none !important;
  padding: 0px !important;
  width: 30px !important;
  height: 30px !important;

  border-radius: 2px;
  background-color: #ffffff;
}

.easy-button-button:hover {
  background-color: #f4f4f4;
}

.upload-active {
  width: 30px !important;
  height: 30px !important;
}

.leaflet-control-zoom-in {
  width: 30px !important;
}

.leaflet-control-zoom-out {
  width: 30px !important;
}

.layer-icon {
  margin-top: 2px;
  font-size: 20px !important;
}
</style>

<style>
.popup {
  min-width: 200px;
  max-height: 150px;
  max-width: 350px;
  overflow-y: auto;
  overflow-x: hidden;
}

.break {
  word-break: break-all;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/mapa/MapaPublico.vue